import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Backdrop } from '../../Backdrop';
import { $showMixin } from '../../mixins/layout';
var TabsBackdrop = styled(Backdrop)(_templateObject(), $showMixin);
export default TabsBackdrop;